import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './pages/Dashboard';
import SelectCourse from './pages/SelectCourse';
import Timetable from './pages/Timetable';
import AcademicCalendar from './pages/AcademicCalendar';
import Feedback from './pages/Feedback';
import Tickets from './pages/Tickets';
import Profile from './pages/Profile';
import Submissions from './pages/Submissions';
import Attendance from './pages/Attendance';
import EventAttendance from './pages/EventAttendance';
import MyExam from './pages/MyExam';
import ExamPaper from './pages/ExamPaper';
import RedirectHandler from './components/RedirectHandler';
import AuthService from './services/authService';

function ProtectedRoute({ children }) {
  const data = AuthService.getUser();
  const hasSession = !!(data && data.apiKey && data.studentId);

  if (!hasSession) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <RedirectHandler />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/app/select-course"
          element={(
            <ProtectedRoute>
              <SelectCourse />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/dashboard"
          element={(
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/submissions"
          element={(
            <ProtectedRoute>
              <Submissions />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/attendance"
          element={(
            <ProtectedRoute>
              <Attendance />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/event-attendance"
          element={(
            <ProtectedRoute>
              <EventAttendance />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/timetable"
          element={(
            <ProtectedRoute>
              <Timetable />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/academic-calendar"
          element={(
            <ProtectedRoute>
              <AcademicCalendar />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/feedback"
          element={(
            <ProtectedRoute>
              <Feedback />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/chat"
          element={(
            <ProtectedRoute>
              <Tickets />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/profile"
          element={(
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/my-exam"
          element={(
            <ProtectedRoute>
              <MyExam />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/my-exam/:examId/start"
          element={(
            <ProtectedRoute>
              <ExamPaper />
            </ProtectedRoute>
          )}
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
